import { render, staticRenderFns } from "./AddUserRole.vue?vue&type=template&id=f40d7902&"
import script from "./AddUserRole.vue?vue&type=script&lang=js&"
export * from "./AddUserRole.vue?vue&type=script&lang=js&"
import style0 from "./AddUserRole.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports